<template>
  <v-card color="#FFFFFF" class="main-card">
    <v-card-text style="padding-bottom: 0;">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-md-6">
            <h3
              style="color:#1E0E62; font-size: 40px;line-height: 1.2; margin-bottom: 1rem;"
            >
              Bienvenido al Registro de Usuario de <strong>SiGeMed!</strong>
            </h3>
            <p
              class="mb-5"
              style="font-size: 16px; line-height: 1.5; color: rgba(21, 20, 57, 0.4)"
            >
              Complete todos los datos del formulario para registrar su usuario,
              se enviará un correo electrónico al E-mail que indique en su
              registro con todas las indicaciones.
            </p>
            <v-form
              class="mb-4"
              ref="form"
              v-model="valid"
              :lazy-validation="lazy"
            >
              <v-row dense class="mb-4">
                <v-col cols="12" sm="6" md="6">
                  <v-text-field
                    v-model="nombre"
                    outlined
                    placeholder="Nombres"
                    maxlength="80"
                    label="Nombres"
                    dense
                    :rules="requiredRules"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-text-field
                    v-model="apellido"
                    outlined
                    label="Apellidos"
                    placeholder="Apellidos"
                    maxlength="80"
                    dense
                    :rules="requiredRules"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="12">
                  <v-text-field
                    v-model="nombreInstitucion"
                    outlined
                    label="Nombre de la Institución"
                    placeholder="Nombre de la Institución"
                    hint="Será utilizado para generar su portal de pacientes personalizado"
                    persistent-hint
                    maxlength="100"
                    dense
                    :rules="requiredRules"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-text-field
                    v-model="mail"
                    placeholder="E-mail"
                    outlined
                    label="E-mail"
                    :rules="emailRules"
                    dense
                    maxlength="80"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-text-field
                    v-model="celular"
                    outlined
                    label="Celular"
                    placeholder="Celular"
                    maxlength="80"
                    dense
                    :rules="requiredRules"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-text-field
                    v-model="matricula"
                    outlined
                    label="Matrícula Profesional"
                    placeholder="Matrícula Profesional"
                    maxlength="10"
                    dense
                    @keypress="onlyNumber"
                    hint="Solo números"
                    :rules="requiredRules"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-select
                    :items="itemsPais"
                    item-text="nombrePais"
                    item-value="idPais"
                    placeholder="País"
                    label="País"
                    dense
                    outlined
                    v-model="pais"
                    :rules="requiredRules"
                  >
                  </v-select>
                </v-col>
                <v-col cols="12" sm="6" md="12">
                  <span
                    style="color: #1E0E62; font-size: 1rem; font-weight: 700;"
                  >
                    Web Portal del Paciente:
                  </span>
                  <span
                    style="color: rgba(21, 20, 57, 0.4); font-size: 1rem; font-weight: 700;"
                    >{{
                      nombreInstitucion
                        ? urlWeb
                        : "Ingrese el nombre de la institución"
                    }}</span
                  >
                </v-col>
              </v-row>
              <v-row dense class="mb-2">
                <v-col cols="12">
                  <span
                    style="color: #1E0E62; font-size: 1rem; font-weight: 700;"
                  >
                    Web Turnero sin Registro:
                  </span>
                  <span
                    style="color: rgba(21, 20, 57, 0.4); font-size: 1rem; font-weight: 700;"
                    >{{
                      nombreInstitucion
                        ? urlTurnero
                        : "Ingrese el nombre de la institución"
                    }}</span
                  >
                </v-col>
              </v-row>
            </v-form>
            <v-card-actions
              style="padding: 0; display: flex; justify-content: space-between; align-items: flex-end; flex-wrap: wrap; gap: 1rem; margin-top: 2rem;"
            >
              <v-btn
                color="#25DAC5"
                :disabled="!valid"
                @click.stop="registrarme"
                style="border-radius: 10px; color: white; text-transform: none;height: 50px;width: 210px; box-shadow: none;"
                >Registrarme</v-btn
              >

              <a
                class="back-link"
                @click="salir"
                style="font-size: 14px; color: rgba(21, 20, 57, 0.4)"
                >Volver a SiGeMed</a
              >
            </v-card-actions>
          </div>
          <div style="width: 100%" class="col-md-6">
            <v-alert
              style="font-size: 21px; line-height: 1.6;"
              color="#1E0E62"
              dark
            >
              Una vez finalizado el registro, te mostraremos aquí mismo cómo
              ingresar al sistema junto con tus credenciales de acceso. Estos
              datos también serán enviados al correo electrónico que indiques
              durante el registro.<br /><br />
              Al ingresar, podrás cambiar tu contraseña, la cual habrá sido
              generada automáticamente. También vas a poder configurar tus días
              y horarios de atención, así como la duración de tus turnos, que
              pueden variar según el día.<br /><br />
              Si estás registrando una institución, podrás cargar profesionales
              adicionales, crear usuarios con distintos roles y configurar los
              accesos de cada uno. Además, vas a poder personalizar toda la
              estructura de tu institución: datos generales, obras sociales,
              topes y tipos de turnos, accesibilidad del portal del paciente y
              muchas funcionalidades más.<br /><br />
              Te recomendamos que nos contactes para conocer todas las
              funcionalidades (¡son muchísimas!) y darte soporte para realizar
              las configuraciones iniciales.<br /><br />
              ¡Esperamos que disfrutes la experiencia!
            </v-alert>
          </div>
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>
<style scoped></style>
<script>
import axios from "../axios-auth.js";
import router from "../router/index.js";
export default {
  data: (vm) => ({
    valid: false,
    lazy: false,
    requiredRules: [(v) => !!v || "Dato obligatorio"],
    emailRules: [
      (v) =>
        !v ||
        /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
        "E-mail inválido",
      (v) => !!v || "Dato obligatorio",
    ],
    nombre: null,
    apellido: null,
    nombreInstitucion: "",
    celular: null,
    mail: null,
    itemsPais: [],
    pais: null,
    matricula: null,
  }),
  computed: {
    sufijoUrl() {
      return this.generarNombreUrl(this.nombreInstitucion);
    },
    urlWeb() {
      return `https://paciente.sigemed.com.ar/portal/${this.sufijoUrl}`;
    },
    urlTurnero() {
      return `https://turnos.sigemed.com.ar/${this.sufijoUrl}`;
    },
  },
  methods: {
    salir() {
      window.location.href = "https://www.sigemed.com.ar";
    },
    generarNombreUrl(nombre) {
      return nombre
        .replace(/\s+/g, " ") // Reemplaza múltiples espacios por uno solo
        .trim() // Elimina espacios al inicio y al final
        .split(" ") // Divide por espacios
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1)) // Fuerza mayúscula en la primera letra de cada palabra
        .join("") // Une sin espacios
        .slice(0, 50); // Limita a 50 caracteres
    },
    onlyNumber($event) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if (keyCode < 48 || keyCode > 57) {
        // 46 is dot
        $event.preventDefault();
      }
    },
    registrarme() {
      this.$swal({
        title: "Registrar Usuario",
        text: "¿Desea registrar el usuario?",
        icon: "success",
        type: "success",
        showCancelButton: true,
        background: "#ececec",
        confirmButtonText: "Si",
        cancelButtonText: "No",
        showCloseButton: true,
        showLoaderOnConfirm: true,
      }).then(async (result) => {
        if (result.value) {
          let self = this;
          const datosUsuario = {
            nombre: this.nombre,
            apellido: this.apellido,
            nombreInstitucion: this.nombreInstitucion,
            mail: this.mail,
            celular: this.celular,
            matricula: this.matricula,
            idPais: this.pais,
            url: this.urlWeb,
            sufijoUrl: this.sufijoUrl,
          };
          const { data: contactData } = await this.registrarContacto(
            datosUsuario
          );
          datosUsuario.idClienteCrm = contactData.contact.id;
          axios
            .post("/Institucional/RegUsu", datosUsuario)
            .then((response) => {
              if (response.data.estadoRegistro == true) {
                self.showAlert({
                  icon: "success",
                  title: "Usuario registrado exitosamente!",
                  vm: self,
                });
                setTimeout(function() {
                  self.guardarNombreUsuPass(
                    response.data.usuario,
                    response.data.clave
                  );
                  self.vaciarModels();
                  router.push("/RegistroExitoso");
                }, 2700);
              } else {
                self.showAlert({
                  icon: "error",
                  title:
                    "El usuario no pudo ser registrado. Intente nuevamente más tarde",
                  vm: self,
                });
              }
            })
            .catch((error) => {
              self.showAlert({
                icon: "error",
                title:
                  "El usuario no pudo ser registrado. Intente nuevamente más tarde",
                vm: self,
              });
            });
        }
      });
    },
    showAlert(alertInfo) {
      alertInfo.vm.$swal.fire({
        icon: alertInfo.icon,
        title: alertInfo.title,
        showConfirmButton: false,
        background: "#ececec",
        timer: 2000,
      });
    },
    vaciarModels() {
      this.nombre = null;
      this.apellido = null;
      this.nombreInstitucion = "";
      this.celular = null;
      this.mail = null;
      this.pais = null;
      this.matricula = null;
    },
    guardarNombreUsuPass(usuario, clave) {
      this.$store.dispatch("guardarNombreUsuClave", {
        nombre: this.nombre + " " + this.apellido,
        usuario: usuario,
        clave: clave,
      });
    },
    async registrarContacto(datosUsuario) {
      const apiKey =
        "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJsb2NhdGlvbl9pZCI6IjVtTWJ2eXY2UXhuRzNERmoxRURuIiwidmVyc2lvbiI6MSwiaWF0IjoxNzUxMDQ5NzA0NDM4LCJzdWIiOiJ5QXhwN0RhdXF2ZFRMUGZhQlVQayJ9.4fvR8EZ_HY8-4KRNuqEA3XiCTL6AhvjhrLEN_V89PCk";
      const url = "https://rest.gohighlevel.com/v1/contacts";
      const data = {
        firstName: datosUsuario.nombre,
        lastName: datosUsuario.apellido,
        email: datosUsuario.mail,
        phone: datosUsuario.celular,
        locationId: "5mMbvyv6QxnG3DFj1EDn",
        source: "Registro Automático",
      };
      const response = await axios.post(url, data, {
        headers: {
          Authorization: `Bearer ${apiKey}`,
          "Content-Type": "application/json",
        },
      });
      return response;
    },
  },
  mounted() {
    let self = this;
    axios
      .get("/Institucional/DamePaises")
      .then((response) => {
        self.itemsPais = response.data;
      })
      .catch((error) => {});
  },
};
</script>
